import React from 'react';

import { Icon } from '../icons';

export const CheckIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M11.6212224,26.6911068 L2.74654706,17.765405 C2.2133732,17.2291656 2.2133732,16.3597143 2.74654706,15.8234212 L4.67737561,13.8814374 C5.21054946,13.3451443 6.07508364,13.3451443 6.6082575,13.8814374 L12.5866633,19.8941634 L25.3917425,7.01551291 C25.9249164,6.47927348 26.7894505,6.47927348 27.3226244,7.01551291 L29.2534529,8.95749673 C29.7866268,9.49373616 29.7866268,10.3631875 29.2534529,10.8994806 L13.5521043,26.6911605 C13.0188771,27.2273999 12.1543962,27.2273999 11.6212224,26.6911068 L11.6212224,26.6911068 Z" />
    </svg>
  );
};
